import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Container,
  Spinner,
  Button,
  Image,
  Form,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { getMyReviewList, toggleHelpful } from "api/ActivityService"; // Create this wrapper
import moment from "moment";
import ReactShowMoreText from "react-show-more-text";
import CommonModal from "components/CommonModal";
import TextInput from "./TextInput";
import { toast } from "react-toastify";
import { addCommentReview, addDisputeCommentReview } from "api/ReviewService";
import { useAuth } from "context/UserContext";
import RatingStars from "./RatingStars";
import { Sentry } from "react-activity";
import IMAGES from "constants/images";
import Loader from "./Loader";

const ProductTwoComponent = ({ userId }) => {
  const [reviews, setReviews] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState("");
  const [selectedReviewId, setSelectedReviewId] = useState(null);
  const [comment, setComment] = useState("");
  const [helpfulMap, setHelpfulMap] = useState({});
  const { user } = useAuth();
  const authId = user?._id;
  const [newReply, setNewReply] = useState("");
  const [showModal, setShowModal] = useState({ data: null, value: false });
  const [selectedReason, setSelectedReason] = useState("");
  const [sendDisputeLoader, setSendDisputeLoader] = useState(false);
  const fetchReviews = async () => {
    try {
      setLoading(true);
      const res = await getMyReviewList("", userId, page, 3, authId); // You create this API wrapper
      if (page === 1) {
        setReviews(res.body.data); // reset
      } else {
        setReviews((prev) => [...prev, ...res.body.data]); // append
      }
      const helpfulStatuses = {};
      res.body.data.forEach((review) => {
        helpfulStatuses[review._id] = review.isHelpul;
      });
      setHelpfulMap(helpfulStatuses);
      setTotalPages(res.body.total_pages);
    } catch (err) {
      console.error("Error fetching reviews", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setReviews([]); // Clear when user changes
    setPage(1);
  }, [userId]);

  useEffect(() => {
    if (userId) fetchReviews();
  }, [userId, page]);

  const handleLoadMore = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };
  const handleCloseModal = () => {
    setShowModal({ data: null, value: false });
    setNewReply("");
  };
  console.log("showModal", showModal);
  const handleSendDispute = async () => {
    try {
      if (selectedReason === "") {
        return toast.error("Please a reason");
      }
      if (newReply.trim() === "") {
        return toast.error("Please enter description");
      }
      setSendDisputeLoader(true);
      const payload = {
        userId: userId,
        reviewId: showModal.data._id,
        productId: showModal.data.productId?._id || showModal.data.productId,
        reason: selectedReason,
        description: newReply.trim(),
      };
      const res = await addDisputeCommentReview(payload);
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        setShowModal({ data: null, value: false });
        setNewReply("");
        setSelectedReason("");
      } else {
        toast.error(res.message);
      }
      setSendDisputeLoader(false);
    } catch (err) {
      setSendDisputeLoader(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleAddComment = async (reviewId) => {
    try {
      if (!comment.trim()) {
        return toast.error("Please enter a comment");
      }

      const payload = {
        userId: userId,
        reviewId: reviewId,
        review: comment,
      };
      const res = await addCommentReview(payload);
      if (res.success === true && res.code === 200) {
        fetchReviews();
        setSelectedReviewId(null);
        setComment("");
        setShow("");
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleHelpfulClick = async (reviewId) => {
    try {
      if (!user) {
        return toast.error("Please login to mark review as helpful");
      }
      const res = await toggleHelpful(reviewId);
      if (res.success) {
        setHelpfulMap((prev) => ({
          ...prev,
          [reviewId]: res.body.isHelpul,
        }));
        fetchReviews();
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {
      console.log("err", err);
      toast.error("Failed to update");
    }
  };

  if (loading && reviews?.length === 0) {
    return (
      <div
        className="text-center py-5 d-flex justify-content-center align-items-center"
        style={{ minHeight: "50vh" }}
      >
        {/* <Spinner animation="border" /> */}
        {/* <Loader style={{ width: 100, height: 100 }} /> */}
        <Sentry color="#e91515" size={40} speed={1} animating={true} />
      </div>
    );
  }

  return (
    <>
      <div
        className="categories_section categories_section1"
        style={{ padding: "0px" }}
      >
        {reviews?.map((review, index) => {
          const product = review.productId;
          return (
            <div className="r_Card mb-4" key={review.id}>
              <div className="headerFLex  headerFLex1 mb-4" style={{wordBreak:"break-all"}}>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                    <Link
                      to={`/product-details/${product.slug}`}
                      style={{
                        backgroundColor: product.brandColors,
                      }}
                      className="iconNewBox"
                    >
                      <img
                        src={product.logoUrl}
                        alt={product.name}
                        style={{ width: 48, height: 48, objectFit: "contain" }}
                      />
                    </Link>
                    <div className="flex-grow-1">
                      <Link
                        to={`/product-details/${product.slug}`}
                        className="text-decoration-none text-dark hoverAnchorColor "
                      >
                        <Card.Title className="mb-2">{product.name}</Card.Title>
                      </Link>
                      <Card.Text className="mb-0">
                        <RatingStars rating={review.overallRating} /> (
                        {product.totalReviews}) {product.avgRating}{" "}
                        <span>out of</span> 5
                      </Card.Text>
                    </div>
                    <div className="d-flex gap-4 helpFull header_profile3 md_hide">
                      {(!user || user?.role === "user") && (
                        <Link
                          onClick={() => handleHelpfulClick(review._id)}
                          className="text-decoration-none d-flex align-items-center"
                          style={{
                            color: helpfulMap[review._id]
                              ? "#0071E3"
                              : "#DC3545",
                          }}
                        >
                          <Icon
                            icon={
                              helpfulMap[review._id]
                                ? "iconamoon:like-fill"
                                : "iconamoon:like-light"
                            }
                            fontSize={22}
                            className="me-2"
                            color={
                              helpfulMap[review._id] ? "#0071E3" : "#DC3545"
                            }
                          />
                          {helpfulMap[review._id]
                            ? "Marked as Helpful"
                            : "Helpful?"}
                          {review?.helpfulCount
                            ? `(${review?.helpfulCount})`
                            : ""}
                        </Link>
                      )}
                      {(!user || user?.role === "user") && (
                        <Link
                          className="text-decoration-none blueColor d-flex align-items-center "
                          onClick={(e) => {
                            if (!user) {
                              e.preventDefault(); // ⛔ Stop navigation
                              toast.error("Please login to view comments");
                            }
                          }}
                          to={`/review-comment/${review?._id}`}
                          // onClick={() => {
                          //   setSelectedReviewId(review._id);
                          //   setShow("comment");
                          // }}
                        >
                          <Icon
                            icon="bx:comment-detail"
                            fontSize={20}
                            className="me-2"
                          />{" "}
                          Comments
                          {review?.totalReplies
                            ? `(${review?.totalReplies})`
                            : ""}
                        </Link>
                      )}
                      {user?.role == "vendor" && (
                        <div className="d-flex gap-4 helpFull">
                          <Link
                            style={{ flexShrink: 0 }}
                            to={`/review-comment/${review?._id}`}
                            className="text-decoration-none redColor d-flex align-items-center"
                          >
                            <Icon
                              icon="flowbite:reply-outline"
                              fontSize={22}
                              className="me-2"
                            />{" "}
                            {review?.totalReplies
                              ? `${review?.totalReplies}`
                              : ""}{" "}
                            Reply
                          </Link>
                          <Link
                            onClick={() =>
                              setShowModal({ data: review, value: true })
                            }
                            className="text-decoration-none blueColor d-flex align-items-center "
                          >
                            <Icon
                              icon="bx:comment-detail"
                              fontSize={20}
                              className="me-2"
                            />{" "}
                            Dispute
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                  <Card.Title
                    className="mb-2"
                    style={{ wordBreak: "break-all" }}
                  >{`"${review.title}"`}</Card.Title>
                  <Card.Text className="mb-3 fw-medium">
                    <RatingStars rating={review.overallRating} />
                    {moment(review?.createdAt).format("LL")}
                  </Card.Text>
                  <ReactShowMoreText
                    lines={2}
                    more="See more"
                    less="See less"
                    anchorClass="see-more-link"
                    expanded={false}
                    width={0}
                    style={{ width: "100%", wordBreak: "break-all" }}
                  >
                    {review.review}
                  </ReactShowMoreText>
                </Card.Body>
        
              </div>
              <div className="d-flex gap-4 helpFull md_show ">
                      {(!user || user?.role === "user") && (
                        <Link
                          onClick={() => handleHelpfulClick(review._id)}
                          className="text-decoration-none d-flex align-items-center"
                          style={{
                            color: helpfulMap[review._id]
                              ? "#0071E3"
                              : "#DC3545",
                          }}
                        >
                          <Icon
                            icon={
                              helpfulMap[review._id]
                                ? "iconamoon:like-fill"
                                : "iconamoon:like-light"
                            }
                            fontSize={22}
                            className="me-2"
                            color={
                              helpfulMap[review._id] ? "#0071E3" : "#DC3545"
                            }
                          />
                          {helpfulMap[review._id]
                            ? "Marked as Helpful"
                            : "Helpful?"}
                          {review?.helpfulCount
                            ? `(${review?.helpfulCount})`
                            : ""}
                        </Link>
                      )}
                      {(!user || user?.role === "user") && (
                        <Link
                          className="text-decoration-none blueColor d-flex align-items-center "
                          onClick={(e) => {
                            if (!user) {
                              e.preventDefault(); // ⛔ Stop navigation
                              toast.error("Please login to view comments");
                            }
                          }}
                          to={`/review-comment/${review?._id}`}
                          // onClick={() => {
                          //   setSelectedReviewId(review._id);
                          //   setShow("comment");
                          // }}
                        >
                          <Icon
                            icon="bx:comment-detail"
                            fontSize={20}
                            className="me-2"
                          />{" "}
                          Comments
                          {review?.totalReplies
                            ? `(${review?.totalReplies})`
                            : ""}
                        </Link>
                      )}
                      {user?.role == "vendor" && (
                        <div className="d-flex gap-4 helpFull">
                          <Link
                            style={{ flexShrink: 0 }}
                            to={`/review-comment/${review?._id}`}
                            className="text-decoration-none redColor d-flex align-items-center"
                          >
                            <Icon
                              icon="flowbite:reply-outline"
                              fontSize={22}
                              className="me-2"
                            />{" "}
                            {review?.totalReplies
                              ? `${review?.totalReplies}`
                              : ""}{" "}
                            Reply
                          </Link>
                          <Link
                            onClick={() =>
                              setShowModal({ data: review, value: true })
                            }
                            className="text-decoration-none blueColor d-flex align-items-center "
                          >
                            <Icon
                              icon="bx:comment-detail"
                              fontSize={20}
                              className="me-2"
                            />{" "}
                            Dispute
                          </Link>
                        </div>
                      )}
                    </div>
            </div>
          );
        })}

        {page < totalPages && (
          <div className="text-center mt-4 d-flex justify-content-center">
            <Button
              variant="outline-primary"
              onClick={handleLoadMore}
              disabled={loading}
              style={{
                width: "351px",
                borderRadius: "50px",
                borderColor: "#0071E3",
                color: "#0071E3",
              }}
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "More Reviews"
              )}
            </Button>
            {/* <button
              onClick={handleLoadMore}
              style={{width:"250px"}}
              className="btn btn-outline-primary"
            >
            {loading ?  <Spinner animation="border" /> : "Load More"}
            </button> */}
          </div>
        )}
        {!loading && reviews?.length === 0 && (
          <Col xs={12}>
            <div className="text-center py-5">
              <Image
                src={IMAGES.emptyState}
                alt=""
                height="300px"
                width="300px"
                className="mb-4"
                // className="imgUser"
              />
              <p className="text-center text-muted">No reviews found.</p>
            </div>
          </Col>
        )}
      </div>
      <CommonModal
        title={"Dispute a Review"}
        para={"Describe your issue, and we’ll review it to find a solution."}
        body={
          <div className="mt-4">
            <Form.Group className="mb-3">
              <Form.Label className="d-block text-start">Reason</Form.Label>
              <Form.Select
                placeholder="Select Reason"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
              >
                <option>Select Reason</option>
                <option>Inappropriate Content</option>
                <option>Spam or Misleading</option>
                <option>Factually Incorrect</option>
                <option>Competitor Review</option>
                <option>Violates Terms of Service</option>
                <option>Other</option>
              </Form.Select>
            </Form.Group>
            <TextInput
              labelText={"Description"}
              type="text"
              textarea="textarea"
              value={newReply}
              onChange={(e) => setNewReply(e.target.value)}
              rows={6}
              maxLength={1000}
              placeholder={"Explain dispute in detail..."}
              // errorMessage="Description is required"
            />

            <Button
              disabled={sendDisputeLoader}
              onClick={handleSendDispute}
              variant="info"
              className="w-100 mt-4 border-radius-100"
            >
              {sendDisputeLoader ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        }
        show={showModal.value}
        onClose={handleCloseModal}
      />

      <CommonModal
        image
        paraStyle={{ maxWidth: "600px", marginTop: "10px" }}
        title="Comment on Review"
        para="Share your thoughts or ask questions about this review to join the conversation and provide additional insights."
        body={
          <>
            <TextInput
              labelText={"Comment"}
              type="email"
              textarea="textarea"
              rows={6}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder={"Write Your Comment..."}
            />
            <Button
              disabled={comment === ""}
              variant="info"
              onClick={() => handleAddComment(selectedReviewId)}
              className="w-100 border-radius-100 mt-3"
            >
              Continue
            </Button>
          </>
        }
        show={show !== ""}
        onClose={() => setShow("")}
      />
    </>
  );
};

export default ProductTwoComponent;
